import React from 'react'
import EventsContainer from './Components/EventsContainer'
import {Icon} from "@iconify/react";
import DefaultTemplate from "../../components/DefaultTemplate/DefaultTemplate";

const Events = () => {
    return (
        <>
            <DefaultTemplate 
                Content={ <EventsContainer/> }
                Title={"Events"}
                icon={<Icon icon="mdi:event" />}
            />
        </>
    )
}

export default Events
